import { useState } from "react";

import { errorMessage } from "../libs/errors";
import { formatPhoneInput, isPhoneComplete, phoneDigits, phoneForRequest } from "../libs/phone";
import { Button } from "./ui/button";
import { Sheet } from "./ui/layout";

// Шторка «Телефон клиента»: когда дисконтной карты нет под рукой. Номер уходит в 1С тем же путём, что скан
// карты, — 1С ищет карту по телефону владельца. Не нашла — номер всё равно записан к консультации.
export function PhoneSheet({ onSubmit, onClose }: { onSubmit: (phone: string) => Promise<void>; onClose: () => void }) {
  const [digits, setDigits] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    setBusy(true);
    setError(null);
    try {
      await onSubmit(phoneForRequest(digits));
      onClose();
    } catch (e) {
      setError(errorMessage(e));
      setBusy(false);
    }
  };

  return (
    <Sheet onClose={busy ? () => undefined : onClose}>
      <h2 className="text-xl font-semibold">Телефон клиента</h2>
      <input
        type="tel"
        inputMode="numeric"
        autoComplete="off"
        autoFocus
        enterKeyHint="done"
        aria-label="Телефон клиента"
        value={formatPhoneInput(digits)}
        onChange={(event) => setDigits(phoneDigits(event.target.value))}
        onKeyDown={(event) => event.key === "Enter" && isPhoneComplete(digits) && !busy && void submit()}
        className="min-h-14 rounded-2xl bg-[var(--color-page)] px-4 text-2xl font-semibold tracking-wide tabular-nums ring-1 ring-[var(--color-line)] outline-none focus:ring-2 focus:ring-[var(--color-accent)]"
      />
      {error && (
        <p role="alert" className="text-sm text-[var(--color-danger)]">
          {error}
        </p>
      )}
      <Button size="lg" loading={busy} disabled={!isPhoneComplete(digits)} onClick={() => void submit()}>
        Найти
      </Button>
      <p className="text-center text-xs text-[var(--color-muted)]">
        Не найдём карту — всё равно запишем номер к консультации.
      </p>
    </Sheet>
  );
}
